module.exports = __webpack_public_path__ + "static/media/sudoku.c3b143b1.svg";